export default __webpack_public_path__ + "static/h1product-1ee47356a0a419e07e7fdb14fd2258bc.png";